import { Link } from "react-router-dom";
import { Gift, Sparkles, MessageCircle, UserRound, ArrowRight, Heart } from "lucide-react";

const PERKS = [[UserRound, "Herz-Profil mit pinkem Haken"], [MessageCircle, "Leuchtende Beiträge & Kommentare"], [Gift, "Monatliche Mystery-Box per Post"], [Gift, "Exklusive Unterstützer-Geschenke im Shop"], [Sparkles, "Rosé-Gold-Name überall in der App"]];
const day = (s) => new Date(s).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });

export function VipMembershipCard({ user }) {
  if (!user.supporter) {
    return (
      <Link to="/community-unterstuetzen" data-testid="vip-teaser" className="group block rounded-3xl p-5 vip-gold-bg text-white vip-sheen">
        <p className="text-[11px] font-extrabold tracking-[0.25em] vip-gold-text">UNTERSTÜTZER-CLUB</p>
        <p className="font-bold mt-1">Werde Projekt Unterstützer 💖</p>
        <p className="text-sm text-stone-300 mt-1">Leuchtendes Herz-Profil, schimmernde Beiträge und exklusive Unterstützer-Geschenke.</p>
        <span className="mt-3 inline-flex items-center gap-1 text-sm font-bold text-amber-300 group-hover:gap-2 transition-[gap]">Mehr erfahren <ArrowRight className="w-4 h-4" /></span>
      </Link>
    );
  }
  const left = user.supporter_until ? Math.max(0, Math.ceil((new Date(user.supporter_until) - Date.now()) / 864e5)) : null;
  return (
    <div className="rounded-3xl p-6 vip-gold-bg text-white vip-sheen shadow-xl shadow-rose-900/25 border border-rose-300/40" data-testid="vip-membership-card">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-[11px] font-extrabold tracking-[0.3em] vip-gold-text">UNTERSTÜTZER-MITGLIEDSCHAFT</p>
          <p className="font-display text-2xl font-extrabold mt-1 vip-gold-text" data-testid="vip-card-name">{user.name}</p>
        </div>
        <span className="w-12 h-12 rounded-2xl bg-gradient-to-br from-pink-300 via-rose-400 to-amber-300 flex items-center justify-center shadow-lg shadow-rose-500/30"><Heart className="w-6 h-6 text-stone-900" fill="currentColor" /></span>
      </div>
      <div className="grid grid-cols-2 gap-3 mt-5 text-sm">
        <div><p className="text-[11px] uppercase tracking-wider text-stone-400">Mitglied seit</p><p className="font-bold" data-testid="vip-card-since">{user.supporter_since ? day(user.supporter_since) : "–"}</p></div>
        <div><p className="text-[11px] uppercase tracking-wider text-stone-400">Gültig bis</p><p className="font-bold" data-testid="vip-card-until">{user.supporter_until ? day(user.supporter_until) : "unbegrenzt"}</p></div>
      </div>
      {left !== null && left <= 7 && <p className="mt-3 text-xs font-semibold text-amber-300" data-testid="vip-card-expiring">Noch {left} {left === 1 ? "Tag" : "Tage"} – verlängere über „Projekt unterstützen“, um Projekt Unterstützer zu bleiben.</p>}
      <ul className="mt-5 grid sm:grid-cols-2 gap-2">
        {PERKS.map(([I, t]) => <li key={t} className="flex items-center gap-2 text-xs text-stone-200"><I className="w-4 h-4 text-rose-200 shrink-0" /> {t}</li>)}
      </ul>
    </div>
  );
}
